import { render, staticRenderFns } from "./LeadsCardEmail.vue?vue&type=template&id=0e4914f0&scoped=true&"
import script from "./LeadsCardEmail.vue?vue&type=script&lang=js&"
export * from "./LeadsCardEmail.vue?vue&type=script&lang=js&"
import style0 from "./LeadsCardEmail.vue?vue&type=style&index=0&id=0e4914f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4914f0",
  null
  
)

export default component.exports